import React, { createContext, useState, useContext, useEffect, ReactNode } from 'react';

interface AppContextType {
  mitMode: boolean;
  setMitMode: (mode: boolean) => void;
  hideMitModal: boolean;
  setHideMitModal: (hide: boolean) => void;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

export const AppProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [mitMode, setMitModeState] = useState<boolean>(() => {
    // Initialize from localStorage to persist across sessions
    return localStorage.getItem('mitMode') === 'true';
  });

  const [hideMitModal, setHideMitModalState] = useState<boolean>(() => {
    return localStorage.getItem('hideMitModal') === 'true';
  });

  const setMitMode = (mode: boolean) => {
    setMitModeState(mode);
    localStorage.setItem('mitMode', String(mode));
  };

  const setHideMitModal = (hide: boolean) => {
    setHideMitModalState(hide);
    localStorage.setItem('hideMitModal', String(hide));
  };

  return (
    <AppContext.Provider value={{ mitMode, setMitMode, hideMitModal, setHideMitModal }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useApp must be used within an AppProvider');
  }
  return context;
};
